module.exports = {"decentralized":{"KurdCoinExchange":{"home":"kurdcoin.exchange"},"KurdWallet":{"home":"kurdwallet.digital","accounts":["GCNSEZUWCMPCBJKJZGDKUTTVYTBGT2JAENGYHLDOJ7IOU35AFSZKR4Z7"]}},"centralized":{"Binance":{"home":"binance.com","accounts":["GCO2IP3MJNUOKS4PUDI4C7LGGMQDJGXG3COYX3WSB4HHNAHKYV5YL3VC"]},"Kraken":{"home":"kraken.com","accounts":["GA5XIGA5C7QTPTWXQHY6MCJRMTRZDOSHR6EFIBNDQTCQHG262N4GGKTM"]}}}


//////////////////
// WEBPACK FOOTER
// ./src/data/exchanges.json
// module id = 442
// module chunks = 37